import React, { useEffect, useState } from 'react';
import { Echarts, OverlayTrigger, PopOver } from '@tencent/spaui';
import { multipleColor, singleColor } from './index';

export const OneCard = (props) => {
  const [labelList, setLabelList] = useState([]);
  const [vlueList, setValueList] = useState([]);
  const height = `${props.height || 200}px`;
  const width = `${props.width || 310}px`;
  const thisPeriodValue = props.data.total || props.data.average;
  const lastPeriodValue = props.data.totalLastPeriod || props.data.averageLastPeriod;
  useEffect(() => {
      if (props.data && props.data.entities) {
      setLabelList(
          props.data.entities.map((item) => ({ value: item.label.slice(5, 10), textStyle: { fontSize: 10 } })),
      );
      setValueList(props.data.entities.map((item) => ({ value: item.value, textStyle: { fontSize: 10 } })));
      }
  }, [props.data]);
  const option = {
      xAxis: {
      type: 'category',
      data: labelList,
      },
      yAxis: {
      type: 'value',
      },
      grid: {
      left: '6%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
      },
      series: [
      {
          data: vlueList,
          type: 'line',
          smooth: true,
          color: singleColor,
          areaStyle: {
          color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
              {
                  offset: 0,
                  color: multipleColor[0], // 0% 处的颜色
              },
              {
                  offset: 1,
                  color: '#fff', // 100% 处的颜色
              },
              ],
              global: false, // 缺省为 false
          },
          },
      },
      ],
  };
  const compareClass = `compare-value ${props.data && thisPeriodValue > lastPeriodValue > 0 ? 'positive' : 'negative'
      }`;
  const compareValue = lastPeriodValue
      ? (((thisPeriodValue - lastPeriodValue) / lastPeriodValue) * 100).toFixed(2)
      : 0;
  return (
      <div className="data-card">
      <div className="card-data-part display-flex">
          <OverlayTrigger
          className="card-name"
          trigger="hover"
          alignment="right"
          overlay={<PopOver>{props.popoverStr}</PopOver>}
          >
          <div className="description-and-icon">
              {props.cardName}
              <i className="spaui-icon icon-help"></i>
          </div>
          </OverlayTrigger>
          <div className="card-value">{props.data ? (props.integer ? thisPeriodValue?.toFixed(0): thisPeriodValue?.toFixed(2)) : 0}{props.isPercent ? '%' : ''}</div>
          {!!lastPeriodValue && (
          <div className="compare-line">
              <span className="compare-str">环比</span>
              <span className={compareClass}>{`${compareValue > 0 ? '+' : ''}${compareValue}%`}</span>
          </div>
          )}
      </div>
      <Echarts
          {...option}
          style={{
          height,
          width,
          }}
      />
      </div>
  );
};
